import SelectInput from "@builder/components/general/ConditionSelectInput";
import "./style.scss";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { useEffect, useMemo, useState } from "react";
import { ActionType, GlobalBlockTypes } from "@common/build/types";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useTranslation } from "react-i18next";
import { useGetGlobalBlocksQuery } from "@builder/store/slices/BuildsApiSlice/buildsApiSlice";
import { skipToken } from "@reduxjs/toolkit/query";

const Print = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const dispatch = useAppDispatch();
    const companyId = useAppSelector(state => state.builder.build.companyId);

    const { data: printBlocks } = useGetGlobalBlocksQuery(
        companyId && GlobalBlockTypes.GB_PRINT ? { companyId, gbType: GlobalBlockTypes.GB_PRINT } : skipToken
    );

    const printBlockNames = useMemo(() => {
        if (printBlocks) {
            return printBlocks.map((block: any) => block.name);
        }
        return [];
    }, [printBlocks]);

    const initialPrintBlockName = useMemo(() => {
        const printBlockId = (actionStep?.action as any)?.gb;
        if (printBlockId && printBlocks) {
            const printBlock = printBlocks.find((block: any) => (block as any)._id === printBlockId || block.id === printBlockId);
            return printBlock?.name || "";
        }
        return "";
    }, [actionStep?.action, printBlocks]);

    const [selectedPrintBlock, setSelectedPrintBlock] = useState<string>(initialPrintBlockName);

    useEffect(() => {
        if (initialPrintBlockName && initialPrintBlockName !== selectedPrintBlock) {
            setSelectedPrintBlock(initialPrintBlockName);
        }
    }, [initialPrintBlockName]);

    const { t } = useTranslation();

    useEffect(() => {
        if (selectedPrintBlock && printBlocks) {
            const printBlock = printBlocks.find((block: any) => block.name === selectedPrintBlock);
            if (printBlock) {
                const printBlockId = (printBlock as any)._id || printBlock.id;
                const action = { type: ActionType.PRINT, gb: printBlockId } as any;
                const updatedStep = {
                    ...actionStep,
                    title: `Selected print block: ${selectedPrintBlock}`,
                    noTranslate: true
                };
                updatedStep.action = { ...action };
                if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
                    dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
                }
            }
        }
    }, [selectedPrintBlock, actionStep, dispatch, id, t, printBlocks]);

    return (
        <div className="action-popup-wrapper">
            <SelectInput
                title="Print setup"
                layout="column"
                value={selectedPrintBlock}
                callback={setSelectedPrintBlock}
                options={printBlockNames}
                placeholder="Select print block"
            />
        </div>
    );
};

export default Print;
